// extracted by mini-css-extract-plugin
export var appointment = "index-module--appointment--am3kE";
export var backHome = "index-module--backHome--QgW0N";
export var content = "index-module--content--FReVI";
export var home = "index-module--home--GnBYJ";
export var homeLink = "index-module--homeLink--F6d8G";
export var homeWrapper = "index-module--homeWrapper--sK9py";
export var icon = "index-module--icon--mHdOo";
export var link = "index-module--link---KZWS";
export var navWrapper = "index-module--navWrapper--N4lKb";
export var right = "index-module--right--XWol+";
export var signUp = "index-module--signUp--d5orW";
export var text = "index-module--text--y7tSk";